import apiCall from "./apiCall";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async fetchStationList(school, page) 
  {
    let data = {
      school_id: school,
      page: page
    };
    let response = await apiCall("station/list", data);
    return response;
  },

  async fetchFewStations(school) 
  {
    let data = {
      school_id: school
    };
    let response = await apiCall("station/few", data);
    return response;
  },

  async createStation(data) 
  {
    let response = await apiCall("station/add", data);
    return response;
  },

  async turnOnStation(data) 
  {
    let response = await apiCall("station/on", data);
    return response;
  },

  async turnOffStation(data) 
  {
    let response = await apiCall("station/off", data);
    return response;
  },
  async updateStation(data) 
  {
    let response = await apiCall("station/update", data);
    return response;
  },
  async updateHours(data) 
  {
    let response = await apiCall("station/update/hours", data);
    return response;
  },
  async searchStation(school, search, page) 
  {
    let data = {
      school_id: school,
      search: search,
      page: page
    };
    let response = await apiCall("station/list", data);
    return response;
  },
  async searchAllStations(search, page) 
  {
    let data = {
      search: search,
      page: page
    };
    let response = await apiCall("station/list", data);
    return response;
  },
  async listAllStations(page) 
  {
    let data = {
      page: page
    };
    let response = await apiCall("station/list", data);
    return response;
  },
  async listGroupedStations(data) 
  {
    let response = await apiCall("station/list/group", data);
    return response;
  },
  async searchGroupedStations(search) 
  {
    let data = {
      search: search
    };
    let response = await apiCall("station/list/group", data);
    return response;
  },
  async completeCallByAdmin(call_id) 
  {
    let data = {
      call_id: call_id
    };
    let response = await apiCall("call_log/admin/complete", data);
    return response;
  },
  async fetchStationTimeRanges(station_id) 
  {
    let data = {
      station_id: station_id
    };
    let response = await apiCall("station/timerange/list", data);
    return response;
  },
  async addStationTimeRange(station_id, start_time, end_time, start_day, end_day) 
  {
    let data = {
      station_id: station_id,
      start_time: start_time,
      end_time:end_time,
      start_day:start_day,
      end_day:end_day
    };
    let response = await apiCall("station/timerange/add", data);
    return response;
  },
  async updateStationTimeRange(time_id, start_time, end_time, start_day, end_day) 
  {
    let data = {
      time_id: time_id,
      start_time:start_time,
      end_time:end_time,
      start_day:start_day,
      end_day:end_day
    };
    let response = await apiCall("station/timerange/update", data);
    return response;
  },
  async fetchStationActivity(data) 
  {
    let response = await apiCall("station/recent_activity", data);
    return response;
  },
  async uninstallStation(data) 
  {
    let response = await apiCall("station/installed/update", data);
    return response;
  },
  async restartStation(data) 
  {
    let response = await apiCall("mobile/webapp/restart_booth", data);
    return response;
  },
  async fetchGlobalStationSettings() {
    let data = {
      type: "global"
    };
    let response = await apiCall("station/setting/list", data);
    return response;
  },

  async fetchSchoolStationSettings() {
    let data = {
      type: "school"
    };
    let response = await apiCall("station/setting/list", data);
    return response;
  },

  async fetchStationSettings() {
    let data = {
      type: "station"
    };
    let response = await apiCall("station/setting/list", data);
    return response;
  },
  async createSetting(auth_method, station_id, school_id) {
    let data = {
      auth_method: auth_method,
      station_id: station_id,
      school_id: school_id
    };
    let response = await apiCall("station/setting/add", data);
    return response;
  },
async enableAuthMethod(id) {
    let data = {
      id: id
    };
    let response = await apiCall("station/setting/enable", data);
    return response;
  },
  async disableAuthMethod(id) {
    let data = {
      id: id
    };
    let response = await apiCall("station/setting/disable", data);
    return response;
  },

  async getAllStationList(data) 
  {
    let response = await apiCall("station/list/all", data);
    return response;
  },

  async restartStationWithSMS(data) 
  {
    let response = await apiCall("mobile/webapp/restart_booth_with_sms", data);
    return response;
  },
  async fetchSIPCredentials(station_id) 
  {
    let data = {
      station_id: station_id
    };
    let response = await apiCall("station/sip/get", data);
    return response;
  },
};
